import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75d24aa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"left","color":"blue"} }
const _hoisted_2 = { style: {"font-size":"13px","color":"#fb2a2a","text-align":"left","margin-left":"5px"} }
const _hoisted_3 = ["model"]
const _hoisted_4 = { class: "wrap_header" }
const _hoisted_5 = {
  key: 0,
  class: "menubar"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-list",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Danh sách đăng ký")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-user-plus",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Thêm nhân viên")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-users",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Danh sách nhân viên")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-ellipsis-h",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Thống kê thông tin")
const _hoisted_14 = {
  key: 1,
  class: "menubar"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-send",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Gởi tin nhắn")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-upload",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Đăng hình ảnh")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-sitemap",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Quản lý nhóm")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-user-plus",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Thêm nhân viên")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-users",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Danh sách nhân viên")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-ellipsis-h",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Thống kê thông tin")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-user-plus",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Đăng ký tài khoản")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-users",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Quản lý tài khoản")
const _hoisted_31 = { class: "logouts" }
const _hoisted_32 = {
  key: 1,
  id: "fotter"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "coppyi" }, "© Copyright 2025 - Trường Đại học Kinh tế - Đại học Đà Nẵng - Designed by voontv@gmail.com")
], -1))
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString($setup.currentTime.toLocaleTimeString('en-GB')) + " " + _toDisplayString($setup.currentTime.toLocaleDateString('en-GB')), 1)
    ]),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "header",
          model: $setup.appMenu
        }, [
          _createElementVNode("div", _hoisted_4, [
            (!$setup.permission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/listRegisterService" }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addemployee" }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showlistemployee" }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showListStatistical" }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/sendmessage" }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/uploadImage" }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/managerGroup" }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addemployee" }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showlistemployee" }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showListStatistical" }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _hoisted_26
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/registerUser" }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _hoisted_28
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/userList" }, {
                        default: _withCtx(() => [
                          _hoisted_29,
                          _hoisted_30
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Button, {
                label: "Đăng xuất",
                style: {"background":"#f34209"},
                onClick: $setup.logout,
                icon: "pi pi-sign-out",
                iconPos: "right",
                class: "p-button-secondary"
              }, null, 8, ["onClick"])
            ])
          ])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
      : _createCommentVNode("", true)
  ], 64))
}